export const DEFAULT_INDUSTRY_CATEGORY_DATABASE_ID = 43

export const INDUSTRY_CATEGORY_DATABASE_ID =
  process.env.NEXT_PUBLIC_WP_INDUSTRY_CATEGORY_DATABASE_ID ??
  DEFAULT_INDUSTRY_CATEGORY_DATABASE_ID

export const INSTANT_REVALIDATION = 10 // 10 secs

export const TEN_MINS_REVALIDATION = 10 * 60 // 10mins

export const SITEMAP_REVALIDATE_TIME = 60 * 10 // 60mins
